import api from "./apiClient";
import {setLoginTokens, getLoginTokens, removeLoginTokens} from "./storageService";

// User Login
export const login = async (userData) => {
	try {
		const response = await api.post("/auth/login", userData);
		setLoginTokens(response.data);
		return response.data;
	} catch (error) {
		throw error.response?.data || "Login failed";
	}
};

// User Registration
export const register = async (userData) => {
	try {
		const response = await api.post("/auth/register", userData);
		return response.data;
	} catch (error) {
		throw error.response?.data || "Registration failed";
	}
};

// Logout User
export const logout = async () => {
	const userAuthData = getLoginTokens();
	try {
		const response = await api.post("/auth/logout", {"jawab_refresh_token": userAuthData.jawab_refreshToken});
		removeLoginTokens(response.data);
		return response.data;
	} catch (error) {
		throw error.response?.data || "Logout failed";
	}
};

// Check if User is Authenticated
export const isAuthenticated = () => {
	return !!localStorage.getItem("token");
};
